"use strict";

import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
import { getOverlayPosition, useLayoutEffect } from "../utils";
import { useState } from "react";
import { useCallback } from "react";
import observeRect from "@reach/observe-rect";
var useOverlayPosition = function useOverlayPosition() {
  var getOverlayPositionProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    targetElement = _useState2[0],
    setTargetElement = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    overlayElement = _useState4[0],
    setOverlayElement = _useState4[1];
  var targetRef = useCallback(function (node) {
    return setTargetElement(node);
  }, []);
  var overlayRef = useCallback(function (node) {
    return setOverlayElement(node);
  }, []);
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    targetRect = _useState6[0],
    setTargetRect = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    overlayRect = _useState8[0],
    setOverlayRect = _useState8[1];
  useLayoutEffect(function () {
    if (!targetElement || !overlayElement) {
      return;
    }
    var targetRectObserver = observeRect(targetElement, setTargetRect);
    var overlayRectObserver = observeRect(overlayElement, setOverlayRect);
    targetRectObserver.observe();
    overlayRectObserver.observe();
    return function () {
      targetRectObserver.unobserve();
      overlayRectObserver.unobserve();
    };
  }, [targetElement, overlayElement]);
  var overlayProps = getOverlayPosition(__spreadValues({
    targetRect: targetRect,
    overlayRect: overlayRect
  }, getOverlayPositionProps));
  return {
    overlayProps: __spreadProps(__spreadValues({}, overlayProps), {
      width: targetRect ? targetRect.width : 0
    }),
    overlayRef: overlayRef,
    targetRef: targetRef,
    targetElement: targetElement
  };
};
export default useOverlayPosition;